import { createAsyncThunk } from '@reduxjs/toolkit';

export const setSearchValueUseCase = createAsyncThunk(
  'setSearchValueUseCase',
  async (
    data: { searchValue: string },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    return {
      searchValue: data.searchValue,
    };
  }
);

export default setSearchValueUseCase;
